import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListStoppedAtCell } from './transaction-list-stopped-at.cell';
import { TransactionListStoppedAtHeader } from './transaction-list-stopped-at.header';

export const TransactionListStoppedAtColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['stoppedAt']
> = {
  enableSorting: true,
  header: TransactionListStoppedAtHeader,
  cell: TransactionListStoppedAtCell,
  meta: { maxWidth: '165px', width: '160px' },
};
